const cinternoitems = {

  background: "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/web/img/MSCI_001.png",

  links: [
    { texto: "Inicio", url: "/Cinterno" },
    { texto: "Metodología", url: "/Cinterno/Metodologia" },
    { texto: "Componentes de Control", url: "/Cinterno/Control" },
    { texto: "Organigrama", url: "/Cinterno/Organigrama" },
    { texto: "Evidencias", url: "/Cinterno/Evidencias" }
  ],

  // =================================================
  // 📥 SECCIÓN DE DESCARGAS (NUEVA)
  // =================================================
  descargas: [
    {
      id: 1,
      titulo: "Formulario de Identificación de Riesgos",
      nombreArchivo: "",
      url: "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/web/cinterno/FIDR.xlsx",
      tipo: "",
      icono: "📊"
    }
  ],

  // =================================================
  // 📄 SECCIÓN DE PDFs (VISUALIZADOR - EXISTENTE)
  // =================================================
  pdfs: [
    {
      id: 3,
      tituloTexto: "Metodología del Sistema de Control Interno y Administración de Riesgos",
      descripcion: "El presente documento es adecuado a la Secretaría de Bienestar e Inclusión Social basado de referencias en materia de control interno para su aplicación y mejora continua de las áreas de oportunidad propiciando reducir la probabilidad de ocurrencia de actos de corrupción y actos contrarios a la integridad de los servidores públicos.",
      tituloPdf: "",
      url: "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/web/cinterno/MSCIyAR.pdf"
    },
  ]

};

export default cinternoitems;